import React, { useState, useEffect } from 'react';
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import * as apiTiposDocumentos from '../../services/apiTiposDocumentos.js';
import * as alerts from '../../functions/alerts.js';


const CrudTable = () => {
  const [loading, setLoading] = useState(true);
  const [data1, setData1] = useState([]); // Estado para almacenar filas
  const [data2, setData2] = useState([]); // Estado para almacenar filas
  const [data3, setData3] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ tipo: '', unico: false, categoria: 0}); // Estado del formulario
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const categorias = [
    { value: 1, label: 'Pólizas' },
    { value: 2, label: 'Clientes' },
    { value: 3, label: 'Siniestros' }
  ];
  // Cargar datos desde la API al montar el componente
    const fetchData = async () => {
        try{
          const [json1, json2, json3] = await Promise.all([
                apiTiposDocumentos.cargarTiposDocumentos(1),
                apiTiposDocumentos.cargarTiposDocumentos(2),
                apiTiposDocumentos.cargarTiposDocumentos(3),
              ]);
          const formatear = (json, categoria) =>
            json.tiposDocs.map((item) => ({
              id: item.id,
              tipo: item.tipo,
              unico: item.unico,
              categoria,
            }));

          setData1(formatear(json1, 1));
          setData2(formatear(json2, 2));
          setData3(formatear(json3, 3));
          setLoading(false);
        } catch (error) {
          console.error('Error al cargar los datos:', error);
      }
    };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
      fetchData();
    }, []);

  // Manejar los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value, type, checked  } = e.target;

    const newValue =
    type === 'checkbox' ? checked :
    name === 'categoria' ? parseInt(value, 10) :
    value;
    setFormData({ ...formData, [name]: newValue });
  };

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = async (catID) => {
      setFormData({ tipo: '' ,unico: false, categoria: catID}); 
      setIsFormModalOpen(true);
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    fetchData();
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  async function handleFormSubmit(e) {
    e.preventDefault();
      const response = await apiTiposDocumentos.crearTipoDocumento(formData, storedUser);
      if (response.ok) {
        alerts.handleSuccess('Éxito!','Tipo documento creado correctamente')
        setIsFormModalOpen(false);
      } else {
        console.error('Error al agregar nuevo tipo documento : ', response.statusText);
      }
      closeFormModal();
    }

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    const response = await apiTiposDocumentos.eliminarTipoDocumento(deleteIndex,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Tipo documento eliminado correctamente')
    } else {
      console.error('Error al eliminar el tipo documento:', response.statusText);
    }
    fetchData();
    closeDeleteModal();
  };

  return (
      <> 
      {/* Tabla */}
      {loading ? <Spinner /> :
      <> 
        <div className="crud-table">
        <h2>Documentos Pólizas</h2>
        <button className='button_new' onClick={() => openFormModal(1)}>Añadir Tipo Documento</button>
        <table>
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Unico</th>
              <th>Categoría</th>
            </tr>
          </thead>
          <tbody>
            {data1.length > 0 ? (
              data1.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.tipo}</td>
                  <td>{item.unico === 1 ? 'Si' : 'No' }</td>
                  <td>
                    {categorias.find(cat => cat.value === item.categoria)?.label || 'Sin categoría'}
                  </td>
                  <td>
                    <button className="eliminar" onClick={() => openDeleteModal(data1[index].id)}>Eliminar</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No hay datos</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        <div className="crud-table">
        <h2>Documentos Clientes</h2>
        <button className='button_new' onClick={() => openFormModal(2)}>Añadir Tipo Documento</button>
        <table>
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Unico</th>
              <th>Categoría</th>
            </tr>
          </thead>
          <tbody>
            {data2.length > 0 ? (
              data2.map((item, index) => (
                <tr key={item.id}>
                  <td>{item.tipo}</td>
                  <td>{item.unico === 1 ? 'Si' : 'No' }</td>
                  <td>
                    {categorias.find(cat => cat.value === item.categoria)?.label || 'Sin categoría'}
                  </td>
                  <td>
                    <button className="eliminar" onClick={() => openDeleteModal(data2[index].id)}>Eliminar</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No hay datos</td>
              </tr>
            )}
          </tbody>
        </table>       
        </div>
        <div className="crud-table">
         <h2>Documentos Siniestros</h2>
        <button className='button_new' onClick={() => openFormModal(3)}>Añadir Tipo Documento</button>
            <table>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Unico</th>
                  <th>Categoría</th>
                </tr>
              </thead>
              <tbody>
                {data3.length > 0 ? (
                  data3.map((item, index) => (
                    <tr key={item.id}>
                      <td>{item.tipo}</td>
                      <td>{item.unico === 1 ? 'Si' : 'No' }</td>
                      <td>
                        {categorias.find(cat => cat.value === item.categoria)?.label || 'Sin categoría'}
                      </td>
                      <td>
                        <button className="eliminar" onClick={() => openDeleteModal(data3[index].id)}>Eliminar</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No hay datos</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      }

      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Añadir Tipo Documento</h2>
            <table>
              <tbody>
                <tr>
                  <td className='modal-region'>
                    <form onSubmit={handleFormSubmit} className='form_crud'>
                      <input
                        type="text"
                        name="tipo"
                        placeholder="Tipo"
                        value={formData.tipo}
                        onChange={handleChange}
                        required
                      />
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        ¿Es único?
                        <input
                          type="checkbox"
                          name="unico"
                          checked={formData.unico}
                          onChange={handleChange}
                        />
                      </label>
                      <select name="categoria" value={formData.categoria} onChange={handleChange}>
                          <option value="">-- Selecciona una Categoría --</option>
                          {categorias.map((cat) => (
                            <option key={cat.value} value={cat.value}>
                              {cat.label}
                            </option>
                          ))}
                      </select>
                    </form>
                  </td>
                  </tr>
                </tbody>
            </table>
            <button type="submit" className='guardar' onClick={handleFormSubmit}>Añadir</button>
            <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
          </div>
        </div>

      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
        
      )}
    </>
  );
};

export default CrudTable;